import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
//	Autoplay,
//HashNavigation,
/*
			hashNavigation: {
				replaceState: true,
			},
			*/
jQuery(($) => {
	if ($(".swiperTestimonials").length > 0) {
		//count number of slides
		const totalSlides = $(".swiperTestimonials .swiper-slide").length;
		if (totalSlides < 2) {
			$(".swiper-pagination").hide();
		}

		const swiperTestimonials = new Swiper(".swiperTestimonials", {
			loop: false,
			centeredSlides: true,
			spaceBetween: 0,
			slidesPerView: 1, //"auto",
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
			},
			modules: [Navigation, Pagination],
			breakpoints: {
				0: {
					spaceBetween: 15,
				},
				768: {
					spaceBetween: 40,
				},
			},
		});
	}
});
